/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const { gql } = require('@apollo/client');

// Collection of all ConversationSummary.
const deps = ['ConversationSummary', 'Collection', 'GatewayApi', '_'];
const factory = function (ConversationSummary, Collection, GatewayApi, _) {
  let ConversationSummaryCollection;
  return (ConversationSummaryCollection = (function () {
    ConversationSummaryCollection = class ConversationSummaryCollection extends Collection {
      static initClass() {
        this.prototype.$id = null;
        this.prototype.$type = ConversationSummary;
        this.prototype.$apiService = GatewayApi;
      }
      $url() {
        return `clients/${this.clientId}/conversations/${this.attachedTo}/summary`;
      }

      $fetch(options = { reset: false }) {
        const query = gql`
          query ConversationSummary($clientId: ID!, $attachedToId: ID!) {
            client(id: $clientId) {
              id
              conversations(attachedToId: $attachedToId) {
                id

                comments {
                  pageInfo {
                    totalCount
                  }
                }

                firstComment: comments(first: 1) {
                  data {
                    authorId
                    authorName
                    authorEmail
                    date
                    body
                    editAuthorId
                    editAuthorName
                    editAuthorEmail
                    edited
                  }
                }

                lastComment: comments(last: 1) {
                  data {
                    authorId
                    authorName
                    authorEmail
                    date
                    body
                    editAuthorId
                    editAuthorName
                    editAuthorEmail
                    edited
                  }
                }
              }
            }
          }
        `;

        const variables = { clientId: this.clientId, attachedToId: this.attachedTo };
        return this.$graphqlClient
          .query({ query, variables, fetchPolicy: 'network-only' })
          .then(res => {
            if (res.data.client.conversations.length > 0) {
              const transformedData = res.data.client.conversations.map(c => ({
                ...c,
                count: c.comments.pageInfo.totalCount,
                firstComment: c.firstComment.data[0],
                lastComment: c.lastComment.data[0],
              }));

              this.$set(transformedData, { reset: options.reset });
            }

            return res;
          });
      }

      $newCount() {
        return _(this.data)
          .filter(comment => comment.isRead === false)
          .size();
      }
    };
    ConversationSummaryCollection.initClass();
    return ConversationSummaryCollection;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/model/conversationSummary').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.conversationSummary', moduleDeps)
  .factory('ConversationSummaryCollection', factory);
